import { IMetadataAuthoringRule, MetadataAuthoringRule } from '@adaptiva/metadata/common';
import { IParentMetadataAuthoringRule } from '../interfaces';

export class OrMetadataAuthoringRule implements IParentMetadataAuthoringRule {

	public type: int;

	public children: IMetadataAuthoringRule[];

	constructor(_children?: IMetadataAuthoringRule[]) {
		this.type = MetadataAuthoringRule.OR;
		if (_children) {
			this.children = _children;
		}
	}
}
